import { atom } from 'jotai'
import { focusAtom } from 'jotai-optics'
import { atomWithListeners, LifecycleState, PersistenceState } from '../../utilities'
import { ConformedCampaignStoryAd, MediaAsset, storyAdDefaultMeta } from '../../views'

export const [storyAdAtom, useStoryAdListener] = atomWithListeners<ConformedCampaignStoryAd | undefined>(
	undefined,
)

export const storyAdStatusAtom = atom<LifecycleState>('idle')
export const storyAdSavingAtom = atom<PersistenceState>('idle')

export const storyAdImageHistoryAtom = atom<Array<MediaAsset>>([])
export const storyAdHasGeneratedContentAtom = atom(false)
export const storyAdAiImageryDetectedAtom = atom(false)

export const storyAdTitleAtom = focusAtom(storyAdAtom, (optic) => optic.optional().prop('title'))
export const storyAdSubtitleAtom = focusAtom(storyAdAtom, (optic) => optic.optional().prop('subtitle'))
export const storyAdLocationAtom = focusAtom(storyAdAtom, (optic) => optic.optional().prop('location'))
export const storyAdCtaTextAtom = focusAtom(storyAdAtom, (optic) => optic.optional().prop('ctaText'))
export const storyAdImageIdAtom = focusAtom(storyAdAtom, (optic) => optic.optional().prop('imageId'))

export const storyAdMetaAtom = focusAtom(storyAdAtom, (optic) => optic.optional().prop('meta'))
export const storyAdMetaTextColorAtom = focusAtom(storyAdMetaAtom, (optic) => optic.optional().prop('textColor'))
export const storyAdMetaLogoBackgroundFillColorAtom = focusAtom(
	storyAdMetaAtom,
	(optic) => optic.optional().prop('logoBackgroundFillColor'),
)

export const storyAdMetaOverlayAtom = focusAtom(storyAdMetaAtom, (optic) => optic.optional().prop('backdropOverlay'))
export const storyAdMetaBackdropOverlayProModeAtom = focusAtom(
	storyAdMetaAtom,
	(optic) => optic.optional().prop('backdropOverlayProMode'),
)
export const storyAdMetaBackdropTransformAtom = focusAtom(
	storyAdMetaAtom,
	(optic) => optic.optional().prop('backdropTransform'),
)

export const storyAdMetaGeneralContentAtom = focusAtom(
	storyAdMetaAtom,
	(optic) => optic.optional().prop('generalContent'),
)
export const storyAdMetaGeneralContentPaddingAtom = focusAtom(
	storyAdMetaGeneralContentAtom,
	(optic) => optic.optional().prop('globalPadding'),
)
export const storyAdMetaGeneralContentFontFamilyOverrideAtom = focusAtom(
	storyAdMetaGeneralContentAtom,
	(optic) => optic.optional().prop('globalFontFamilyOverride'),
)
export const storyAdMetaGeneralContentHideAtom = focusAtom(
	storyAdMetaGeneralContentAtom,
	(optic) => optic.optional().prop('hide'),
)

export const storyAdMetaPositioningAtom = focusAtom(storyAdMetaAtom, (optic) => optic.optional().prop('positioning'))
export const storyAdMetaLogoPositionAtom = focusAtom(
	storyAdMetaPositioningAtom,
	(optic) => optic.optional().prop('logo'),
)
export const storyAdMetaLocationPositionAtom = focusAtom(
	storyAdMetaPositioningAtom,
	(optic) => optic.optional().prop('location'),
)
export const storyAdMetaAttributionPositionAtom = focusAtom(
	storyAdMetaPositioningAtom,
	(optic) => optic.optional().prop('attribution'),
)
export const storyAdMetaStackOrientationAtom = focusAtom(
	storyAdMetaPositioningAtom,
	(optic) => optic.optional().prop('stackOrientation'),
)

export const storyAdMetaTitleTextLayerAtom = focusAtom(
	storyAdMetaAtom,
	(optic) => optic.optional().prop('titleTextLayer'),
)
export const storyAdMetaTitleTextTransformAtom = focusAtom(
	storyAdMetaAtom,
	(optic) => optic.optional().prop('titleTextTransform'),
)

export const storyAdMetaSubtitleTextLayerAtom = focusAtom(
	storyAdMetaAtom,
	(optic) => optic.optional().prop('subtitleTextLayer'),
)
export const storyAdMetaSubtitleTextTransformAtom = focusAtom(
	storyAdMetaAtom,
	(optic) => optic.optional().prop('subtitleTextTransform'),
)

export const storyAdMetaForceAiGeneratedLabelAtom = focusAtom(
	storyAdMetaAtom,
	(optic) => optic.optional().prop('forceAiGeneratedLabel'),
)

// canvas
export const storyAdMetaCanvasEnabledAtom = focusAtom(
	storyAdMetaAtom,
	(optic) => optic.optional().prop('canvasEnabled'),
)
export const storyAdCanvasLoadCounterAtom = atom(0)
export const storyAdMetaCanvasDocumentAtom = focusAtom(
	storyAdMetaAtom,
	(optic) => optic.optional().prop('canvasDocument'),
)
